/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

/**
 * Which master/source a system-applied value came from. Null for OCR-inferred values.
 */
export type InferenceDetailSourceDetail =
  | (typeof InferenceDetailSourceDetail)[keyof typeof InferenceDetailSourceDetail]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InferenceDetailSourceDetail = {
  payee: 'payee',
  counterparty: 'counterparty',
  received_invoice: 'received_invoice',
  report: 'report',
} as const;
